import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  padding: 0px 20px 40px 20px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  overflow: hidden;
`;

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;

  .left-section {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .title {
    display: flex;
    gap: 4px;
  }
`;

export const PageTitle = styled.div`
  display: flex;
  padding: 24px 20px;
  align-items: center;
  gap: 12px;
`;

export const PageDate = styled.div`
  //*예약 현황 옆, 날짜 선택 컴포넌트
  display: flex;
  align-items: center;
  gap: 20px;

  .date-page {
    display: flex;
    align-items: center;
    gap: 12px;
  }
`;

export const FilterContainer = styled.div`
  display: flex;
  padding: 0px 20px;
  align-items: center;
  align-self: stretch;
  gap: 40px;
  padding-top: 8px;
  padding-bottom: 24px;
`;

export const FilterItemContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const MeetingRoomListContainer = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  box-sizing: border-box;
  align-items: center;
  min-width: 1150px;
  width: 100%;
  overflow-x: hidden;
`;

export const ArrowContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  height: 76px;
`;

export const TimeTableLayout = styled.div`
  /* position: relative; */
  display: flex;
  width: 100%;
  overflow: auto;
  box-sizing: inherit;
`;

export const TimeTableScrollContainer = styled.div`
  position: relative;
  display: flex;
  min-width: 1150px;
  width: 100%;
  align-items: flex-start;
  align-self: stretch;
  justify-content: flex-start;
`;

export const MeetingRoomReservationListContainer = styled.div`
  display: flex;
  position: absolute;
  width: 100%;
  left: 0;
  top: 8px;
  gap: 32px;
  justify-content: center;
`;

export const EmptyMeetingRoomList = styled.div`
  flex: 1;
  height: 100px;
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
`;

export const LeftSideContainer = styled.div`
  padding-left: 20px;
  gap: 20px;
  display: flex;
  flex-direction: column;
`;

export const CenterSideContainer = styled.div`
  width: calc(100% - 152px);
  height: calc(100vh - 352px);
  display: flex;
  gap: 24px;
  box-sizing: border-box;
  margin-left: 76px;
  overflow: hidden;
  box-sizing: inherit;
`;

export const Circle = styled.div<{ scrollOffset: number }>`
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: var(--alias-color-label-neutral);
  right: 92px;
  top: ${(props) => props.scrollOffset}px;
  bottom: -6px;
  z-index: 1;
`;

export const MeetingRoomContainer = styled.div`
  display: flex;
  gap: 24px;
  padding-bottom: 20px;
  width: 100%;
  z-index: 1;
`;

export const MeetingRoomListWrapper = styled.div`
  display: flex;
  width: 100%;
  overflow: hidden;
  /* overflow-x: auto; */
`;
